@let b = block();

<dfn class="app-tooltip__dnf">
    i
</dfn>
<div class="app-tooltip__inner-div">
    {{ b.text }}
    <div class="app-tooltip__triangle"></div>
</div>
